module.exports = __webpack_public_path__ + "static/media/clear.74be7dfc.png";